module.exports = __webpack_public_path__ + "img/img12@2x.c1765b74.png";